import React from "react";
import Header from "./Header";
import Navbar from "./Navbar";
import HeroCarousel from "./HeroCarousel";
import "./HomePage.css";
import Collections from "./Collections";
import OfferBanner from "./OfferBanner";
import ShopByCategory from "./ShopByCategory";
import TryAtHomeSection from "./TryAtHomeSection";
import OurPromise from "./OurPromise";
import VideoBannerSection from "./VideoBannerSection";
import GemstoneGalloreSection from "./GemstoneGalloreSection";
import HomeShowcaseSection from "./HomeShowcaseSection";
import HomeBlogSection from "./BlogSection";
import TestimonialsSection from "./TestimonialsSection";
import SubscribeSection from "./SubscribeSection";
import Footer from "./Footer";
import HelpTrigger from "./HelpTrigger";

const HomePage = () => {
  return (
    <div className="homepage">
      <Header />
      <Navbar />
      <HeroCarousel />

          <Collections />
          <HomeShowcaseSection/>
          <OfferBanner/>
          <GemstoneGalloreSection/>
          <ShopByCategory/>
                  <VideoBannerSection />
          <TryAtHomeSection/>
          <OurPromise/>
          <HomeBlogSection/>
          <TestimonialsSection/>
         <SubscribeSection/>
         <Footer/>
         <HelpTrigger/>
    </div>
  );
};

export default HomePage;
